import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSEO from "@/lib/useSEO";

export const TRUST_LINKS = [
  ["About", "/about"],
  ["Methodology", "/methodology"],
  ["Contact", "/contact"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
  ["Disclaimer", "/disclaimer"],
];

export default function TrustLayout({ meta, children }) {
  useSEO({
    title: meta.title,
    description: meta.description,
    canonicalPath: meta.path,
  });
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-[#5C6B62] hover:text-[#2B5339] mb-8"
        >
          <ArrowLeft size={14} /> Back to calculator
        </Link>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-2">
          {meta.kicker}
        </div>
        <h1 className="text-4xl sm:text-5xl font-medium text-[#1C2B23] leading-tight mb-3">
          {meta.h1}
        </h1>
        {meta.reviewed && (
          <div className="text-xs text-[#5C6B62]">Last reviewed: {meta.reviewed}</div>
        )}
        <div className="mt-8 space-y-5 text-[#1C2B23] leading-relaxed text-[15px]">
          {children}
        </div>
        <div className="mt-14 border-t border-[#E5E2DC] pt-6 flex flex-wrap gap-x-5 gap-y-2">
          {TRUST_LINKS.map(([label, href]) => (
            <Link key={href} to={href} className="text-xs text-[#5C6B62] hover:text-[#2B5339]">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export const H2 = ({ children }) => (
  <h2 className="text-2xl font-medium mt-10 mb-1">{children}</h2>
);
